import { render, staticRenderFns } from "./setList.vue?vue&type=template&id=454a7258&scoped=true"
import script from "./setList.vue?vue&type=script&lang=js"
export * from "./setList.vue?vue&type=script&lang=js"
import style0 from "./setList.vue?vue&type=style&index=0&id=454a7258&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a7258",
  null
  
)

export default component.exports